<template>
    <div id="app">
        <router-view />
    </div>
</template>

<script>
export default {
    name: 'App',
    data() {
        return {
            isRouterAlive: true
        }
    },
    methods: {

    },
    created() {
        // console.log('sessionStorage', typeof sessionStorage, sessionStorage);
        this.$toast.allowMultiple()
        var loading = this.$tool.cookie.get('config.loading');
        if (!loading) {
            this.$api.post('index/store/h5/index/getConfig')
                .then((res) => {
                    if (res.code == 200) {
                        this.$tool.cookie.set('config.loading', true, 86400);
                        this.$tool.data.set('config', res.data);
                    } else {
                        this.$toast.fail('页面配置加载失败，' + res.message)
                    }
                }).catch((err) => {
                    console.log(err);
                });

        }
    }
}
</script>



// WEBPACK FOOTER //
// src/App.vue